import {useUserStore} from '@/stores/user'

export default {
    mounted(el, binding) {
        const tableName = binding.value
        const userStore = useUserStore()
        
        const hasAccess = !!userStore.access(tableName)
        if (!hasAccess && el.parentElement) {
            el.parentElement.removeChild(el)
        }
    }
}